import api from "./axios";

export async function getStoreBridgeDevices() {
  const response = await api.get("/store-bridge/devices");
  return response.data || [];
}

export async function createStoreBridgePairingCode(name = "Cashier workstation") {
  const response = await api.post("/store-bridge/devices/pairing-code", { name });
  return response.data;
}

export async function updateStoreBridgeSettings(deviceId, payload) {
  const response = await api.put(
    `/store-bridge/devices/${encodeURIComponent(deviceId)}/settings`,
    payload,
  );
  return response.data;
}

export async function getStoreBridgeJobStatus(deviceId, jobId) {
  const response = await api.get(
    `/store-bridge/devices/${encodeURIComponent(deviceId)}/jobs/${encodeURIComponent(jobId)}`,
  );
  return response.data;
}

export async function queueStoreBridgeTestReceipt(deviceId) {
  const response = await api.post(
    `/store-bridge/devices/${encodeURIComponent(deviceId)}/test-receipt`,
    {},
  );
  return response.data;
}

export async function queueStoreBridgeTestDrawer(deviceId) {
  const response = await api.post(
    `/store-bridge/devices/${encodeURIComponent(deviceId)}/test-drawer`,
    {},
  );
  return response.data;
}

export async function queueStoreBridgeSaleReceipt(deviceId, salePublicId, idempotencyKey) {
  const response = await api.post(
    `/store-bridge/devices/${encodeURIComponent(deviceId)}/sales/${encodeURIComponent(salePublicId)}/receipt`,
    {},
    { headers: { "Idempotency-Key": idempotencyKey } },
  );
  return response.data;
}

export async function revokeStoreBridgeDevice(deviceId) {
  const response = await api.post(
    `/store-bridge/devices/${encodeURIComponent(deviceId)}/revoke`,
    {},
  );
  return response.data;
}
